import { Observable } from 'rxjs';
import { ApiResponse } from '../common/api-response';

export abstract class TaxesRepository {
    abstract get(page: number, limit: number): Observable<ApiResponse<any>>;
    abstract getById(id: number): Observable<ApiResponse<any>>;
    abstract create(body: any): Observable<ApiResponse<any>>;
    abstract update(id: number, body: any): Observable<ApiResponse<any>>;
    abstract delete(id: number): Observable<ApiResponse<any>>;
}
